import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { SessionService } from '../session.service';
import { BetSlipPlacementResponse, BetSlipTicketPayload } from './betslip-ticket.models';

@Injectable({ providedIn: 'root' })
export class BetSlipTicketService {
  private readonly http = inject(HttpClient);
  private readonly session = inject(SessionService);

  placeTicket(payload: BetSlipTicketPayload): Observable<BetSlipPlacementResponse> {
    const user = this.session.currentUser();
    const language = user?.DefaultLanguage || this.session.currentLanguage();
    const isMobile = this.session.isMobile();
    const url = `${environment.apiUrl}/Api/Ticket?IsMobile=${isMobile}&IsPrint=false&IsSlim=false&Lang=${language}`;

    return this.http.post<BetSlipPlacementResponse>(url, payload, {
      withCredentials: true
    });
  }
}
